;(function ($) {

    $(document).ready(function(){
        teammatesSlider();
    });

    //functions
    function teammatesSlider(){     
        $('.teammates-slider').slick({
            dots: true,
            arrows: false,
            nextArrow: '<div class="box"><img src="/wp-content/themes/cmac/assets/images/icons/left-arrow-gray.svg" alt="right arrow" class="box-slick-arrow box-arrow-next"></div>',
            prevArrow: '<div class="box left-box"><img src="/wp-content/themes/cmac/assets/images/icons/left-arrow-gray.svg" alt="left arrow" class="box-slick-arrow box-arrow-prev"></div>',
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            pauseOnFocus: true,
            centerMode: true,
            variableWidth: false,
            appendDots: '#teammates-nav',
            appendArrows: '#teammates-nav',
            responsive: [
                {
                  breakpoint: 9999,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 769,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
        });
    }


})(jQuery);